export interface IContentProps {
    searchPlaceholderText: string;
    searchButtonText: string;
    filtersSectionHeader: string;
    resetButtonText: string;
    preSearchMessage: string;
    noResultsMessage: string;
    contextItems: string[];
    contextPlaceholderText: string;
    sortsLabel: string;
    relevanceSortText: string;
    dateSortText: string;
    reverseDateSortText: string;
    dateSortRelevanceFilter: number;
    generalErrorText: string;
    loadingResultsText: string;
    zeroResultsText: string;
    numberOfResultsText: string;
    pageSize: number;
    hideStudentCount: boolean;
    studentCountLabel: string;
    hidePhoneNumber: boolean;
    phoneNumberLabel: string;
    hideNetwork: boolean;
    networkLabel: string;
    hideGovernance: boolean;
    governanceLabel: string;
    hidePrograms: boolean;
    programsLabel: string;
    hideProgramTypes: boolean;
    programTypesLabel: string;
    hideRating: boolean;
    ratingLabel: string;
    hideAdaAccessibility: boolean;
    adaAccessibilityLabel: string;
    hideDressCode: boolean;
    hasDressCodeLabel: string;
    hideGradesOffered: boolean;
    gradesOfferedLabel: string;
    hideMapLink: boolean;
    mapLinkUrl: string;
    hideAddress: boolean;
    addressLabel: string;
    hideGoCPS: boolean;
    isGoCPSLabel: string;
    reverseAlphabeticalSortText: string;
    alphabeticalSortText: string;
    hideCampusAccessibility: boolean;
    hideParkingAccessibility: boolean;
    campusAccessibilityLabel: string;
    parkingAccessibilityLabel: string;
    contextBlockItems: IContextItem[];
    searchResultFields: IResultField[];
    proximityFields: IProximityField[];
}

export interface IContextItem {
    contextName: string;
    defaultSort: string;
}

export interface IResultField {
    resultFields: string;
    fieldDisplayName: string;
    shouldHide: boolean;
}

export interface IProximityField {
    displayName: string;
    value: string;
}

export const DefaultContentProps = {
    searchPlaceholderText: '',
    searchButtonText: '',
    filtersSectionHeader: '',
    resetButtonText: '',
    preSearchMessage: '',
    noResultsMessage: '',
    contextItems: [],
    contextPlaceholderText: '',
    sortsLabel: '',
    relevanceSortText: '',
    dateSortText: '',
    reverseDateSortText: '',
    dateSortRelevanceFilter: '',
    generalErrorText: '',
    loadingResultsText: '',
    zeroResultsText: '',
    numberOfResultsText: '',
    pageSize: 10,
    hideStudentCount: false,
    studentCountLabel: '',
    hidePhoneNumber: false,
    phoneNumberLabel: '',
    hideNetwork: false,
    networkLabel: '',
    hideGovernance: false,
    governanceLabel: '',
    hidePrograms: false,
    programsLabel: '',
    hideProgramTypes: false,
    programTypesLabel: '',
    hideDessCode: false,
    hasDressCodeLabel: '',
    hideGradesOffered: false,
    gradesOfferedLabel: '',
    hideMapLink: false,
    mapLinkUrl: '',
    hideAddress: false,
    addressLabel: '',
    HideGoCPS: false,
    isGoCPSLabel: '',
    hideAdaAccessibility: false,
    adaAccessibilityLabel: '',
    hideCampusAccessibility: false,
    hideParkingAccessibility: false,
    campusAccessibilityLabel: '',
    parkingAccessibilityLabel: '',
    reverseAlphabeticalSortText: '',
    alphabeticalSortText: '',
    contextBlockItems: [],
    ratingLabel: '',
    searchResultFields: []
}